import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem, IconButton, Box } from '@mui/material';
import { ReactComponent as MoreIcon } from '../../../../assets/images/more.svg';
import { deletePackage, patchPackageStatus } from '../../../../store/bonuses/actions';
import { useDispatch } from 'react-redux';

export const More = ({ id, status }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (e) => {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const handleArchivePackage = () => {
    dispatch(patchPackageStatus(id, { status: status === 'created' ? 'archive' : 'created' }));
  };

  const handleDeletePackage = () => {
    dispatch(deletePackage(id));
  };

  return (
    <>
      <Box>
        <IconButton onClick={handleClick}>
          <MoreIcon data-testid="MoreIcon" />
        </IconButton>

        <Menu
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button'
          }}>
          <MenuItem
            onClick={(e) => {
              handleClose(e);
              handleArchivePackage();
            }}
            sx={{}}
            data-testid="ArchiveBonus">
            {status === 'created' ? 'Архивировать' : 'Извлечь из Архива'}
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              handleClose(e);
              handleDeletePackage();
            }}
            sx={{
              color: 'error.main'
            }}
            data-testid="DeleteBonusPackage">
            Удалить
          </MenuItem>
        </Menu>
      </Box>
    </>
  );
};

More.propTypes = {
  id: PropTypes.any,
  status: PropTypes.string
};
